import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import { CustomSnackbar, Footer, Header } from "../shared"; // Adjust paths as needed
import { motion } from "framer-motion";
import { useUtility } from "utils/context/UtilityContext"; // Adjust path as needed
import { VideoDisplay } from "./texts"; // Adjust path as needed
import { useYoutubeUrlManager } from "utils/hooks/useYoutubeUrlManager";

export const YoutubeUrlManager = () => {
  const {
    youtubeUrl,
    setYoutubeUrl,
    initialLoading,
    isSaving,
    snackbar,
    handleSaveYoutubeUrl,
    handleSnackbarClose,
  } = useYoutubeUrlManager();

  const { marginBottomHeader } = useUtility();

  // Main loading state for the initial data fetch
  if (initialLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`flex flex-col min-h-screen ${marginBottomHeader}`}
    >
      <Header />

      {/* Use Container for responsive max-width and padding */}
      <Container maxWidth="lg" sx={{ flexGrow: 1, py: { xs: 3, md: 5 } }}>
        <Paper sx={{ p: { xs: 2, md: 4 } }}>
          <Stack spacing={3}>
            <Typography variant="h4" component="h1" gutterBottom>
              Gérer la vidéo YouTube
            </Typography>

            {/* Video Preview */}
            <Box sx={{ width: '100%', maxWidth: 720, alignSelf: 'center', aspectRatio: '16/9' }}>
              <VideoDisplay videoLink={youtubeUrl} width="100%" />
            </Box>

            {/* Input for YouTube URL */}
            <TextField
              label="Lien YouTube"
              placeholder="https://www.youtube.com/watch?v=..."
              value={youtubeUrl}
              onChange={(e) => setYoutubeUrl(e.target.value)}
              fullWidth
              margin="normal"
            />

            {/* Save button with loading state */}
            <Box>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveYoutubeUrl}
                disabled={isSaving}
                startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {isSaving ? "Sauvegarde..." : "Sauvegarder le lien"}
              </Button>
            </Box>
          </Stack>
        </Paper>
      </Container>

      <Footer />

      {/* Snackbar for success or failure messages */}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        // This is the fix for your CustomSnackbar
        isSuccess={snackbar.severity === "success"} 
        handleClose={handleSnackbarClose}
      />
    </motion.div>
  );
};